import React, { useState } from 'react'
import { Modal, Tabs } from 'antd'
import closeIcon from 'assets/Images/close.svg'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { infoMessage } from 'api/global'
import { defaultActivitiesResp, GetActivitiesTypes } from 'types/event/events'
import DefalutActivityTab from 'pages/Events/Views/CreateEvent/Screens/Step2/Modals/DefalutActivityTab'
import SpecificActivtyTab from 'pages/Events/Views/CreateEvent/Screens/Step2/Modals/SpecificActivtyTab'
import AddActivity from 'pages/Events/Views/CreateEvent/Screens/Step2/Modals/addActivity/AddActivity'

// Reuse exact same modal styling as Events Step2
import 'pages/Events/Views/CreateEvent/Screens/Step2/Modals/styles/styles.scss'

export type TemplateSelectedActivity = {
  activity: defaultActivitiesResp
  isDefault: boolean
}

interface TemplateSelectActivityModalProps {
  modalOpen: boolean
  setmodalopen: React.Dispatch<React.SetStateAction<boolean>>
  organizationId: string
  onConfirm: (selected: TemplateSelectedActivity) => void
  loading?: boolean
}

const TemplateSelectActivityModal: React.FC<TemplateSelectActivityModalProps> = ({
  modalOpen,
  setmodalopen,
  organizationId,
  onConfirm,
  loading,
}) => {
  const [addActivityModal, setAddActivityModal] = useState<boolean>(false)
  const [params, setParams] = useState<GetActivitiesTypes>({
    organizationId,
    defaultActivities: true,
  })
  const [selectedActivity, setSelectedActivity] = useState<defaultActivitiesResp>()

  const handleCancel = () => setmodalopen(false)

  const handleCreateNewActivity = () => {
    setAddActivityModal(true)
  }

  const handleConfirm = () => {
    if (!selectedActivity) return infoMessage('Please select an activity')
    onConfirm({ activity: selectedActivity, isDefault: !!params.defaultActivities })
    setSelectedActivity(undefined)
    handleCancel()
  }

  const onChange = (key: string) => {
    if (key === '1') setParams(prev => ({ ...prev, defaultActivities: true }))
    else setParams(prev => ({ ...prev, defaultActivities: false }))
  }

  const items = [
    {
      key: '1',
      label: 'Default',
      children: (
        <DefalutActivityTab
          closeModal={setmodalopen}
          params={params}
          selected={selectedActivity as any}
          setSelected={setSelectedActivity as any}
        />
      ),
    },
    {
      key: '2',
      label: 'Specific',
      children: (
        <SpecificActivtyTab
          closeModal={setmodalopen}
          params={params}
          selected={selectedActivity as any}
          setSelected={setSelectedActivity as any}
        />
      ),
    },
  ]

  return (
    <>
      <Modal open={modalOpen} onCancel={handleCancel} className="select-activityModal" footer={false}>
        <div className="flex-center pt-20px justify-between ">
          <h2 className="w-600 text-18">Select activity</h2>
          <img
            src={closeIcon}
            alt="close-button"
            onClick={handleCancel}
            className="close button pointer"
          />
        </div>
        <div className="mt-10px text-center activity-select-container">
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        </div>

        <div className="mt-30px flex align-center justify-between">
          <button className="create-activity-btn" onClick={handleCreateNewActivity}>
            Create new activity
          </button>
          <button className="confirm-btn" onClick={handleConfirm} disabled={!!loading}>
            {loading ? <ButtonSpinner size={20} color="#000" /> : 'Confirm'}
          </button>
        </div>
      </Modal>

      <AddActivity modalOpen={addActivityModal} setModalOpen={setAddActivityModal} />
    </>
  )
}

export default TemplateSelectActivityModal

